module.exports = __webpack_public_path__ + "img/login.c8a09163.jpg";